module.exports = __webpack_public_path__ + "static/media/mainicon3.3e87d31e.png";